import React from "react";
import { Link, useLocation } from "react-router-dom";
import TeamShell from "./TeamShell";

const MESSAGES = {
  bestaetigt: {
    title: "Buchung bestätigt",
    lead: "Der Termin wurde bestätigt. Der Kunde erhält eine Bestätigungs-E-Mail.",
  },
  storniert: {
    title: "Bereits storniert",
    lead: "Diese Buchung wurde bereits storniert.",
  },
  ungueltig: {
    title: "Link ungültig",
    lead: "Der Link ist abgelaufen oder ungültig.",
  },
};

const StaffBookingResultPage = () => {
  const params = new URLSearchParams(useLocation().search);
  const aktion = params.get("aktion");
  const fehler = params.get("fehler");
  const status = params.get("status");

  const key = aktion || fehler;
  const preset = MESSAGES[key];
  const title = preset?.title || (status ? `Status: ${status}` : "Erledigt");
  const lead =
    preset?.lead ||
    (status
      ? "Diese Buchung hat bereits einen anderen Status."
      : "Die Aktion wurde verarbeitet.");

  return (
    <TeamShell>
      <section className="team-login">
        <div className="auth-card team-login-card" style={{ maxWidth: "28rem" }}>
          <p className="auth-kicker">Dr. Hoffmann · Team</p>
          <h1>{title}</h1>
          <p className="auth-lead">{lead}</p>
          <div className="auth-actions">
            <Link to="/admin-dashboard" className="auth-submit" style={{ textAlign: "center" }}>
              Zum Admin-Dashboard
            </Link>
          </div>
        </div>
      </section>
    </TeamShell>
  );
};

export default StaffBookingResultPage;
